export const iconFontAwesomeMedicalHealthVialVirus = (
	<i className="fa-solid fa-vial-virus"></i>
);
